import wx from "weixin-js-sdk"; // 微信sdk依赖
import { get } from "@/http/request.js";

function getJSSDK(dataForWeixin) {
  let params = {
    url: window.location.href.split("#")[0]
  };
  get("/hcfm-cloud-manage-app/site/rest/pgc/wxShare/getSignature", params).then(res => {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.data.appId, // 必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.noncestr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名
      jsApiList: [
        "onMenuShareAppMessage",
        "onMenuShareTimeline",
        "updateAppMessageShareData",
        "updateTimelineShareData"
      ] // 必填，需要使用的JS接口列表
    });
    wx.ready(function () {
      let { title, desc, linkurl, img } = dataForWeixin;
      let shareData = {
        title: title,
        desc: desc, //这里请特别注意是要去除html
        link: linkurl,
        imgUrl: img,
        success: function (res) {
          alert("分享成功！");
        },
        fail: function (res) {
          // alert("fail");
        }
      };
      // 兼容新老版本接口
      if (wx.onMenuShareAppMessage) {
        wx.onMenuShareAppMessage(shareData); // 1.0 分享到朋友(即将废弃)
        wx.onMenuShareTimeline(shareData); // 1.0 分享到朋友圈(即将废弃)
      } else {
        wx.updateAppMessageShareData(shareData); // 1.4 分享到朋友
        wx.updateTimelineShareData(shareData); // 1.4 分享到朋友圈
      }
    });
  });
}

export default {
  // 获取JSSDK
  getJSSDK
};
